import BaseService from 'vue-core/services/BaseService';
import env from 'environment';

class TaxonomyService
    extends BaseService {
  taxonomies() {
    return this.get({
      url: env.baseUrl + '/taxonomies'
    });
  }

  load({ type, date }) {
    return this.get({
      url: env.baseUrl + '/taxonomies/' + date + '/' + type
    });
  }
}

const service = new TaxonomyService();

export default service;
